import { useMemo } from "react";
import { useFeatureBetaGroups } from "../../FeatureBetaGroups/hooks/useFeatureBetaGroups";
import DSAutocomplete from "../../system-design/DSAutocomplete";
import DSTextField from "../../system-design/DSTextField";

type FeatureBetaGroupFilterProps = {
  groupId: string;
  onChange: (groupId: string | null) => void;
};

const FeatureBetaGroupFilter = ({
  groupId,
  onChange,
}: FeatureBetaGroupFilterProps) => {
  const { data: groups, isLoading } = useFeatureBetaGroups();

  const options = useMemo(
    () => [...(groups ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
    [groups],
  );

  return (
    <DSAutocomplete
      size="small"
      sx={{ width: 260 }}
      options={options}
      loading={isLoading}
      value={options.find((group) => group.id === groupId) ?? null}
      getOptionLabel={(group) => `${group.name} (${group.memberCount})`}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      noOptionsText="No feature beta groups"
      onChange={(_, group) => onChange(group?.id ?? null)}
      renderInput={(params) => (
        <DSTextField {...params} label="Feature beta group" />
      )}
    />
  );
};

export default FeatureBetaGroupFilter;
